// extracted by mini-css-extract-plugin
module.exports = {"root":"Italic_root__2DjUa"};